import React, { FC, useEffect, useState } from 'react';
import { SequenceType, DragDirection, Coordinate, DragInfo } from '../../models/index'
import * as Sequencer from '../../image_sequence2'
import './SequenceView.css';
import { ImagePreloader } from '../../image_preloader';

interface SequenceViewProps {
  id: string;
  prefix: string;
  completion: ((finished: boolean) => void);
  tapToProgress?: (() => void)
  tapLocation?: Coordinate
  start: number;
  end: number;
  height: number;
  width: number;
  suffix: string;
  framesPerSecond?: number;
  sequenceType: SequenceType;
  dragDirection: DragDirection;
  imagePreloader?: ImagePreloader,
  dragInfo?: DragInfo
}

var sequence: Sequencer.DragableImageSequence
var pinchSequence: Sequencer.PinchableImageSequence
var progressSequence: Sequencer.ImageSequence
var currentPrefix: string

export function animateSequence(start: number, end: number, completion: ((finished: boolean) => void)) {
    progressSequence.animateToFrameWithCompletion(end - start, () => {
        completion(true)
    })
}

const SequenceView: FC<SequenceViewProps> = ({ id, prefix, completion, tapLocation, start, end, height, width, suffix, framesPerSecond = 30, sequenceType, dragDirection, imagePreloader, dragInfo}: SequenceViewProps) => {

  const [loaded, setLoaded] = useState(false)
  const [seqId, setSeqId] = useState(id)

  useEffect(() => {
    if (!loaded || seqId !== id) {
        setLoaded(true)
        if (seqId !== id) {
            setSeqId(id)
        }
        completion(false)
        if (document.getElementsByClassName('sequence-view-tap')[0]) {
            document.getElementsByClassName('sequence-view-tap')[0].classList.remove('hidden')
        }
        if (document.getElementsByClassName('sequence-drag-help')[0]) {
            document.getElementsByClassName('sequence-drag-help')[0].classList.remove('animate')
            document.getElementsByClassName('sequence-drag-help')[0].classList.remove('dragging')
        }
        currentPrefix = prefix
        switch (sequenceType) {
            case SequenceType.Draggable:
                sequence = new Sequencer.DragableImageSequence(document.getElementById(`${seqId}`), width, height, prefix, start, end, suffix, dragDirection, false)
                if (imagePreloader) {
                    sequence.imagePreloader = imagePreloader
                }
                if (framesPerSecond !== 30) {
                    sequence.mult *= framesPerSecond / 30;
                }
                sequence.didCompleteSequence = () => {
                    completion(true)
                }
                sequence.callbackDragStarted = () => {
                    document.getElementsByClassName('sequence-drag-help')[0].classList.add('animate','dragging')
                }
                sequence.jumpToFrame(0)
                break;
            case SequenceType.Pinchable:
                pinchSequence = new Sequencer.PinchableImageSequence(document.getElementById(`${seqId}`), width, height, prefix, start, end, suffix, dragDirection, false)
                pinchSequence.didCompleteSequence = () => {
                    completion(true)
                }
                pinchSequence.jumpToFrame(0)
                break;
            case SequenceType.Progress:
                if (progressSequence) {
                    progressSequence.pause()
                }
                progressSequence = new Sequencer.ImageSequence(document.getElementById(`${seqId}`), width, height, prefix, start, end, suffix)
                progressSequence.framesPerSecond = framesPerSecond
                if (imagePreloader) {
                    progressSequence.imagePreloader = imagePreloader
                }
                progressSequence.jumpToFrame(0)
                progressSequence.animateToFrameWithCompletion(end - start, () => {
                    completion(true)
                })
                break;
            case SequenceType.TapToProgress:
                progressSequence = new Sequencer.ImageSequence(document.getElementById(`${seqId}`), width, height, prefix, start, end, suffix)
                progressSequence.framesPerSecond = framesPerSecond
                if (imagePreloader) {
                    progressSequence.imagePreloader = imagePreloader
                }
                progressSequence.jumpToFrame(0)
                break;
            default:
              console.log('shouldn\'t be here')
        }    
    } else if (currentPrefix !== prefix) {
        completion(false)
        setLoaded(false)
    }
  }, [seqId, id, prefix, completion, tapLocation, start, end, height, width, suffix, framesPerSecond, sequenceType, dragDirection, loaded, imagePreloader])

  function dragHelp() {
    if (dragInfo) {
        return (
            <>
                <div className='sequence-drag-help' style={{left: `${dragInfo.origin.x}px`, top: `${dragInfo.origin.y}px`, rotate: `${dragInfo.rotation}deg`, scale: `${dragInfo.scale}`}} />
            </>
        )
    }
    return null
  }
  return (
    <>
        <div id={seqId} className="SequenceView" />
        {tapLocation &&
            <div 
                className="sequence-view-tap" 
                style={{ top: `${tapLocation.y}px`, left: `${tapLocation.x}px` }} 
                onClick={() => {
                    document.getElementsByClassName('sequence-view-tap')[0].classList.add('hidden')
                    progressSequence.animateToFrameWithCompletion(end - start, () => {
                        completion(true)
                    })
                }} 
            />
        }
        {dragInfo && dragHelp()}
    </>
  )
  
};

export default SequenceView;
